'use client';

import { EligibilityState } from '@/lib/eligibility/eligibilitySlice';
import { useAppSelector } from '@/lib/hooks';

const useEligibilityData = (): EligibilityState => {
  const eligibility = useAppSelector((state) => state.eligibility);
  return eligibility;
};

export default useEligibilityData;
